<f-chart
  [view]="view"
  [xScale]="xScale"
  [yScale]="yScale"
  [animation]="animation"
  [fitContainer]="fitContainer"
  [truncateXAxisTicks]="truncateXAxisTicks"
  [truncateYAxisTicks]="truncateYAxisTicks"
  [rotateXAxisTicks]="rotateXAxisTicks"
  [maxXAxisTickLength]="maxXAxisTickLength"
  [maxYAxisTickLength]="maxYAxisTickLength"
  [maxYAxisTicksCount]="maxTicksCount"
  [xAxisTickFormatting]="xAxisTickFormatting"
  [yAxisTickFormatting]="yAxisTickFormatting"
  [showXAxisGridlines]="showXAxisGridlines"
  [showYAxisGridlines]="showYAxisGridlines"
  [showXAxisTicksLabels]="showXAxisTicksLabels"
  [showYAxisTicksLabels]="showYAxisTicksLabels"
  [showLineAxisTicksLabels]="showLineAxisTicksLabels"
  [xAxisTickLabelClasses]="xAxisTickLabelClasses"
  [xAxisTickLabelOffset]="xAxisTickLabelOffset"
  [showBarsOptionalData]="showBarsOptionalData"
  [showXAxisDomain]="showXAxisDomain"
  [showYAxisDomain]="showYAxisDomain"
  [popoverPlacement]="popoverPlacement"
  [popoverTemplate]="popoverTemplate"
  [leftAxisLabelText]="leftAxisLabelText"
  [labelsOffset]="labelsOffset"
  [showBorders]="showBorders"
  [showLabels]="showLabels"
  [condensedOnDesktop]="condensedOnDesktop"
  [showLegend]="showLegend"
  [legendOptions]="legendOptions"
  [condensedAxisOnMobile]="condensedAxisOnMobile"
  [chartPatternsTemplate]="chartPatternsTemplate"
  (dimensionsChanged)="onDimensionsChanged($event)"
>
  <svg:g
    *ngIf="dimensions"
    f-bar-series
    [series]="data"
    [xScale]="xScale"
    [yScale]="yScale"
    [factorInfo]="factorInfo"
    [highlightedIndexRange]="highlightedIndexRange"
    [dimensions]="dimensions"
    [barClasses]="barClasses"
    [animation]="animation"
    [condensedOnDesktop]="condensedOnDesktop"
    [interactions]="interactions"
    [parentChartComponent]="chartComponent"
    [animationDuration]="animationDuration"
    [popoverTemplate]="popoverTemplate"
    [popoverPlacement]="popoverPlacement"
    [popoverOpenDelay]="popoverOpenDelay"
    [showOptionalData]="showBarsOptionalData"
    [barBubbleScaleFactor]="infoBubbleScaleFactor"
    [barBubbleTextClasses]="infoBubbleTextClasses"
    [barBubbleClasses]="infoBubbleClasses"
    [activeBarIndex]="activeBarIndex"
    (seriesClick)="onBarClick($event)"
    (seriesHover)="onBarHover($event)"
  />
</f-chart>
